import React from 'react';
import {Box, IconButton, Tooltip, Typography} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {useTranslation} from "react-i18next";

export interface InfoFieldProp { label: string; value: string; copyable?: boolean }

const InfoField = ({ label, value, copyable}: InfoFieldProp) => {
    const {t} = useTranslation();

    return (
        <Box sx={{ minWidth: 0}}>
            <Typography variant="caption" sx={{ textTransform: 'uppercase', fontWeight: 400 }}>
                {label}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography variant="body1" component="p" fontWeight={500}>
                    {value}
                </Typography>

                {copyable && (
                    <Tooltip title={t('licenseManager.main.copyToClipboard')}>
                        <IconButton
                            size="small"
                            aria-label={t('licenseManager.main.copyToClipboard') as string}
                            onClick={() => navigator.clipboard.writeText(value)}
                        >
                            <ContentCopyIcon fontSize="inherit" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        </Box>
    );
}



interface LicenseInformationSetProps {
    fields: InfoFieldProp[];
}

const LicenseInformationSet = ({ fields }: LicenseInformationSetProps) => {
    return (
        <Box sx={{
                flex: 1,
                minWidth: 0,
                display: "grid",
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                gridAutoFlow: { sm: 'column' },
                gridTemplateRows: { sm: 'repeat(3, auto)' },
                gap: 4,
            }}
        >
            {fields.map((field) => (
                <InfoField key={field.label} {...field} />
            ))}
        </Box>
    );
};


export default LicenseInformationSet;